import { Injector } from '@angular/core';

import { CookieService } from 'ngx-cookie-service';

// Services
import { AuthService } from '@auth/auth.service';

// Configs
import { COOKIE_ENUMERATION } from '@home/login/configs';
import { ProductType } from '@core/model/enums';

// Types
import { LoanRedirectOptionsType, RedirectionHandlerType } from '../models';

// Environment
import { environment } from '@environments/environment';

export class RFRedirectionHandler implements RedirectionHandlerType {
  private readonly authService: AuthService;
  private readonly cookieService: CookieService;

  constructor(private readonly injector: Injector) {
    this.authService = this.injector.get(AuthService);
    this.cookieService = this.injector.get(CookieService);
  }

  public canHandle(options: LoanRedirectOptionsType): boolean {
    const { origin, conditions } = options;
    return origin === ProductType.RF && (!conditions || conditions === ProductType.RF);
  }

  public handle(): void {
    this.cookieService.set(COOKIE_ENUMERATION.CRFRAP, this.authService.token, 1, '/', environment.domain);
    window.location.href = environment.myCreditsRapiflex;
  }
}
